import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/buysellads': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 150.7l42.9 160.7h-85.8zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM382.7 405.3l-94.5-298.7h-128.4l-94.5 298.7h90.7l111.7-91.6 24.2 91.6h90.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/buysellads.js
// module id = 738
// module chunks = 0